import React from "react";
import CheckboxContainer from "../../../../../ui/layout/page/forms-container/form-item-container/checkbox-container";
import CheckboxField from "../../../../shared/components/formik/checkbox";
import SectionFullWidthContainer from "../../../../../ui/layout/page/forms-container/section-full-width-container";
import AddressSelect from "../../../../shared/components/address-select";
import InputContainer from "../../../../../ui/layout/page/forms-container/form-item-container/input-container";
import Country from "../../../../shared/components/country";
import { useMessageSource } from "react-message-source";
import { FlexibleInvoicingModel } from "../types";

export const CentralizedBillingAltAddress = ({
  dataPath,
  flexibleInvoicing,
}: {
  dataPath: string;
  flexibleInvoicing: FlexibleInvoicingModel;
}): React.JSX.Element => {
  const { getMessage } = useMessageSource();
  const { hasFlexibleInvoicingAddress, address, fullStreet } =
    flexibleInvoicing;
  return (
    <>
      <div className="scd-section-pusher-md">
        <CheckboxContainer>
          <CheckboxField
            name={`${dataPath}hasFlexibleInvoicingAddress`}
            label={getMessage(
              "FlexibleInvoicing.DifferentCompanyAddressOption.accept",
            )}
          />
        </CheckboxContainer>
      </div>
      {hasFlexibleInvoicingAddress && (
        <SectionFullWidthContainer>
          <AddressSelect
            fullStreet={fullStreet}
            address={address}
            dataPath={dataPath}
            isBusinessAddress
          />
          <InputContainer>
            <Country dataPath={dataPath} value={address.country} forCompany />
          </InputContainer>
        </SectionFullWidthContainer>
      )}
    </>
  );
};
